const baseInitialValues = {
  adults_quantity: 1,
  minors_quantity: 0,
  date_from: '',
  date_to: '',
  first_name: '',
  last_name: '',
  whatsapp: '',
  plates: 1,
  sites: 1,
  minors_ages: [],
  email: '',
  plate_link: '',
};

export const initialValues = {
  ...baseInitialValues,
  id_entity: '',
};

export const initialValuesCCO = {
  ...baseInitialValues,
};
